// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n5mf","col":"styles_col__3K6VH"};